import Vue from 'vue';
import * as moment from 'moment';

export default Vue.filter('timeFormatAmPm', value => moment(value, ['hh:mm']).format('h:mm A'));


// WEBPACK FOOTER //
// ./src/filters/timeFormatAmPm.js